import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';
const CardIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        viewBox="0 0 20 16"
        ref={ref}
        fill={props.color}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        width="20"
        height="16"
      >
        <path
          d="M12 10C12 9.44771 12.4477 9 13 9H16C16.5523 9 17 9.44771 17 10C17 10.5523 16.5523 11 16 11H13C12.4477 11 12 10.5523 12 10Z"
          fill={props.color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 2C0 0.895431 0.89543 0 2 0H18C19.1046 0 20 0.89543 20 2V14C20 15.1046 19.1046 16 18 16H2C0.895432 16 0 15.1046 0 14V2ZM2 8V14H18V8C18 8 18 8 18 8H2ZM18 4C18 4 18 4 18 4H2V2L18 2L18 4Z"
          fill={props.color}
        />
      </svg>
    );
  }
);
export default CardIcon;
